import { Maybe } from 'graphql/jsutils/Maybe'
import { COUNTRIES, usStatesOptions, canadianStatesOptions } from 'constants/countriesStates'
import { IActivationPageHighwayQuery } from '../pages/activation/graphql/ActivationPageHighway'
import { IActivationPageHighwayInsurancePolicyFragment } from '../pages/activation/graphql/ActivationPageHighwayInsurancePolicyFragment'

export type IGetHighwayCarrierInfoState = {
  address: Maybe<string>
  address2: Maybe<string>
  city: Maybe<string>
  continuousAuthorityGrantDate: Maybe<string>
  country: Maybe<string>
  countryCode: Maybe<string>
  emailAddress: Maybe<string>
  highwayId: Maybe<string>
  insurancePolicies: IActivationPageHighwayInsurancePolicyFragment[]
  isHighwayInfoComplete: boolean
  phone: Maybe<string>
  state: Maybe<string>
  zipcode: Maybe<string>
}

export const getHighwayCarrierInfo = (
  carrierData: Maybe<IActivationPageHighwayQuery>
): IGetHighwayCarrierInfoState | null => {
  if (!carrierData) {
    return null
  }

  const { highwayCarrier } = carrierData || {}
  const {
    insurancePolicies = [],
    addresses = [],
    contacts = [],
    continuousAuthorityGrantDate,
    highwayId,
  } = highwayCarrier || {}

  const physicalAddress = addresses?.find(address => address.isType === 'physical')
  const activeAddress = physicalAddress ?? addresses?.find(address => address.isType === 'mailing')

  const { city, countryCode, postalCode: zipcode, stateCode, street1: address, street2: address2 } =
    activeAddress || {}

  const isCountryUS = countryCode === COUNTRIES[0].code
  const country = isCountryUS ? 'United States' : 'Canada'
  const stateOptions = isCountryUS ? usStatesOptions : canadianStatesOptions
  const stateName = stateOptions.find(state => state.value === stateCode)
  const { value: state } = stateName || {}

  const dispatchContact = contacts?.find(contact => contact.isType === 'dispatch')
  const { emailAddress = '', phone = '' } = dispatchContact || {}

  // If any of these fields are empty, step 1 of BCA defaults to the manual form
  const isHighwayInfoComplete =
    Boolean(address) && Boolean(city) && Boolean(countryCode) && Boolean(state) && Boolean(zipcode)

  return {
    address,
    address2,
    city,
    continuousAuthorityGrantDate,
    country,
    countryCode,
    emailAddress,
    highwayId,
    insurancePolicies,
    isHighwayInfoComplete,
    phone,
    state,
    zipcode,
  }
}
